<template>
  <div class="school-details-page">
    <headers />

    <!-- Breadcrumb 面包屑导航 -->
    <div class="details-sub-nav">
      <div class="breadcrumb-container">
        <span
          class="breadcrumb-item cursor-pointer"
          @click="$router.push({ path: '/school/index', query: { tab: 0 } })"
          >首页</span
        >
        <span class="breadcrumb-separator"></span>
        <span
          class="breadcrumb-item cursor-pointer"
          @click="$router.push({ path: '/school/index', query: { tab: 1 } })"
          >课程学习</span
        >
        <span class="breadcrumb-separator"></span>
        <span
          class="breadcrumb-item cursor-pointer"
          @click="$router.push({ path: '/school/index', query: { tab: 2 } })"
          >学习课表</span
        >
        <span class="breadcrumb-separator"></span>
        <span class="breadcrumb-item active">课程包详情</span>
      </div>
    </div>

    <!-- Main Content Container 主版面 -->
    <div class="details-content-wrap">
      <!-- 课程包大卡片区 (卡片上左右布局) -->
      <div class="details-header-card">
        <!-- 左侧封面大图 -->
        <div class="package-cover-container">
          <img
            v-if="detail.cover"
            :src="detail.cover || ''"
            class="package-big-cover"
          />
        </div>

        <!-- 右侧信息描述与操作 -->
        <div class="info-container">
          <div class="info-top">
            <div class="info-title-row">
              <div class="info-title textOverflowOne">
                {{ detail.title }}
              </div>
            </div>
            <div class="info-subtitle textOverflowOne" v-if="detail.subtitle">
              {{ detail.subtitle }}
            </div>
            <!-- <div class="info-desc textOverflowThree" v-if="detail.intro">
              介绍：{{ detail.intro || "暂无相关介绍" }}
            </div> -->
          </div>

          <div class="info-bottom">
            <!-- 订阅人数 -->
            <div class="meta-row">
              <div class="meta-item">
                <img class="meta-icon" src="@/assets/school/Icon4.png" alt="" />
                <span class="meta-value"
                  >{{ detail.subscribeCount || 0 }}人订阅</span
                >
              </div>
            </div>

            <!-- 操作按钮 -->
            <div class="action-row">
              <el-button
                type="primary"
                class="learn-btn btnTransform"
                @click="handleSubscribe"
              >
                {{ detail.subscribed ? "取消订阅" : "订阅" }}
              </el-button>
            </div>
          </div>
        </div>
      </div>

      <!-- 下方卡片区 (章节目录大列表) -->
      <div class="directory-section-wrap">
        <!-- 栏目标题 -->
        <div class="directory-section-title-row">
          <div class="title-left-bar"></div>
          <div class="title-text">学习课表详情</div>
        </div>

        <!-- 目录体 -->
        <div
          class="directory-list-container"
          v-if="detail.subList && detail.subList.length"
        >
          <!-- 每一个模块对应的独立卡片 -->
          <div
            class="chapter-card"
            v-for="(chapter, cIdx) in detail.subList"
            :key="chapter.id || cIdx"
          >
            <!-- 章节灰色头部 -->
            <div class="chapter-header-row">
              <div class="chapter-step-badge-wrap">
                <div class="chapter-step-badge">Step{{ cIdx + 1 }}</div>
              </div>
              <div class="chapter-header-title">{{ chapter.title }}</div>
            </div>

            <!-- 章节内容体 -->
            <div class="chapter-body-content">
              <!-- 章节重点与目标 (左右卡片布局) -->
              <div
                class="chapter-goals-box"
                v-if="chapter.focus || chapter.target"
              >
                <!-- 重点卡片 -->
                <div class="goal-card" v-if="chapter.focus">
                  <div class="goal-icon-wrap">
                    <div class="goal-icon-block">
                      <img src="@/assets/school/Icon1.png" alt="" />
                    </div>
                  </div>
                  <div class="goal-info">
                    <div class="goal-title">重点</div>
                    <div class="goal-text">{{ chapter.focus }}</div>
                  </div>
                </div>

                <!-- 目标卡片 -->
                <div class="goal-card" v-if="chapter.target">
                  <div class="goal-icon-wrap">
                    <div class="goal-icon-block">
                      <img src="@/assets/school/Icon2.png" alt="" />
                    </div>
                  </div>
                  <div class="goal-info">
                    <div class="goal-title">目标</div>
                    <div class="goal-text">{{ chapter.target }}</div>
                  </div>
                </div>
              </div>

              <!-- 学习内容列表区域 -->
              <div class="chapter-content-list-section">
                <!-- 学习内容标题条 -->
                <div class="content-list-title-row">
                  <div class="content-list-icon">
                    <img src="@/assets/school/Icon3.png" alt="" />
                  </div>
                  <div class="content-list-title-text">
                    学习内容 ·
                    {{ chapter.courseList ? chapter.courseList.length : 0 }}
                  </div>
                </div>

                <!-- 章节下属课程列表 -->
                <div class="chapter-courses-list">
                  <div
                    class="sub-course-card"
                    v-for="(course, sIdx) in expandedSteps[cIdx]
                      ? chapter.courseList
                      : (chapter.courseList || []).slice(0, 3)"
                    :key="course.id || sIdx"
                    @click="toCourseDetails(course)"
                  >
                    <div class="sub-course-left">
                      <div class="sub-course-number">
                        <div class="num-text">{{ sIdx + 1 }}</div>
                      </div>
                      <div class="sub-course-info">
                        <div class="sub-course-title-wrap">
                          <div class="sub-course-title textOverflowOne">
                            {{ course.name }}
                          </div>
                        </div>
                        <div
                          class="sub-course-badge"
                          :class="course.completed ? 'completed' : 'pending'"
                        >
                          <div class="badge-text">
                            {{ course.completed ? "已完成" : "未完成" }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="sub-course-action">
                      <div class="action-text">去学习</div>
                      <div class="action-arrow-icon">
                        <i class="el-icon-arrow-right"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 查看更多课程按钮 -->
                <div
                  class="view-more-courses-btn"
                  v-if="chapter.courseList && chapter.courseList.length > 3"
                  @click="toggleStepExpand(cIdx)"
                >
                  <span class="view-more-text">{{
                    expandedSteps[cIdx] ? "收起课程" : "查看更多课程"
                  }}</span>
                  <span class="view-more-arrow">
                    <i
                      :class="
                        expandedSteps[cIdx]
                          ? 'el-icon-arrow-up'
                          : 'el-icon-arrow-down'
                      "
                    ></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <None v-else />
      </div>
    </div>

    <footers />
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import None from "@/components/none.vue";
import { coursePackageView, coursePackageSubscribe } from "@/api/lx";

export default {
  name: "packageDetails",
  components: {
    headers,
    footers,
    None,
  },
  data() {
    return {
      packageId: "",
      detail: {
        cover: "",
        id: "",
        intro: "",
        subscribeCount: 0,
        subscribed: false,
        subtitle: "",
        title: "",
        subList: [],
      },
      expandedSteps: {}, // 记录每一个Step的展开状态
    };
  },
  created() {
    this.packageId = this.$route.query.id || "";
    if (this.packageId) {
      this.getDetails();
    } else {
      this.$message.error("课程包ID缺失");
    }
  },
  methods: {
    /**
     * 拉取课程包详情
     */
    getDetails() {
      coursePackageView(this.packageId)
        .then((res) => {
          this.detail = res.data || {};
        })
        .catch((err) => {
          console.error("加载课程包详情出错:", err);
          this.$message.error("课程包加载失败");
        });
    },
    /**
     * 处理课程包的订阅或取消订阅操作
     * @returns {void}
     */
    handleSubscribe() {
      if (!this.packageId) return;
      coursePackageSubscribe(this.packageId)
        .then((res) => {
          if (res.code === 200) {
            const nextSubscribed = !this.detail.subscribed;
            // this.detail.subscribed = nextSubscribed;
            if (nextSubscribed) {
              this.$message.success("订阅课程包成功！");
            } else {
              this.$message.success("已取消订阅课程包");
            }
            // 重新加载详情以同步最新的订阅人数
            this.getDetails();
          } else {
            this.$message.error(res.msg || "操作失败");
          }
        })
        .catch((err) => {
          console.error("订阅操作出错:", err);
          this.$message.error("操作失败，请稍后重试");
        });
    },
    /**
     * 切换特定 Step 的展开/收起状态
     * @param {number} stepIdx - Step 索引
     * @returns {void}
     */
    toggleStepExpand(stepIdx) {
      this.$set(this.expandedSteps, stepIdx, !this.expandedSteps[stepIdx]);
    },
    /**
     * 寻找第一门课程并跳转
     */
    startFirstCourse() {
      if (this.detail.subList && this.detail.subList.length) {
        for (let i = 0; i < this.detail.subList.length; i++) {
          const list = this.detail.subList[i].courseList || [];
          if (list.length) {
            this.toCourseDetails(list[0]);
            return;
          }
        }
      }
      this.$message.info("暂无可学习课程");
    },
    /**
     * 跳转至子课程详情页
     * @param {Object} course - 课程项
     */
    toCourseDetails(course) {
      if (!course.canView) {
        this.$message.warning("抱歉，当前课程暂无权限学习");
        return;
      }
      this.$router.push({
        path: "/school/details",
        query: {
          id: course.id,
          classifyName: "课程包",
          classifyId: this.packageId,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
/* Page Layout styles */
.school-details-page {
  width: 100%;
  min-height: 100vh;
  background-color: #f9fafc;
  display: flex;
  flex-direction: column;
}

/* Breadcrumb nav styles */
.details-sub-nav {
  width: 100%;
  height: 64px;
  background: #ffffff;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(186, 202, 198, 0.2);
  box-sizing: border-box;

  .breadcrumb-container {
    width: 1200px;
    margin: 0 auto;
    padding: 0 24px;
    display: flex;
    align-items: center;
    gap: 8px;
    box-sizing: border-box;
  }

  .breadcrumb-item {
    font-size: 14px;
    color: #6b7a77;
    font-weight: 500;
    transition: color 0.2s;

    &.cursor-pointer:hover {
      color: #00d8c3;
    }

    &.active {
      color: #00161a;
      font-weight: 700;
    }
  }

  .breadcrumb-separator {
    width: 4px;
    height: 4px;
    background: #bacac6;
    border-radius: 9999px;
    margin: 0 4px;
  }
}

.details-content-wrap {
  width: 1200px;
  margin: 0 auto;
  padding: 32px 24px 80px 24px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  box-sizing: border-box;
}

/* Header Card layout (Top row) */
.details-header-card {
  width: 100%;
  height: 202px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid rgba(186, 202, 198, 0.3);
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  padding: 24px;
  display: flex;
  gap: 32px;
  box-sizing: border-box;
}

.package-cover-container {
  width: 273px;
  height: 154px;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  background: #f2f4f6;
  flex-shrink: 0;

  .package-big-cover {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.info-container {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 154px;
  box-sizing: border-box;
  padding: 0;
}

.info-top {
  display: flex;
  flex-direction: column;
  gap: 11px;
}

.info-title-row {
  display: flex;
  align-items: flex-start;

  .info-title {
    color: #191c1e;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
}

.info-subtitle {
  color: #6b7a77;
  font-size: 15px;
  font-weight: 500;
  text-align: left;
}

.info-desc {
  color: rgba(59, 74, 71, 0.8);
  font-size: 14px;
  font-weight: 400;
  line-height: 23px;
  text-align: left;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.info-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.meta-row {
  display: flex;
  align-items: center;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 6px;

  .meta-icon {
    width: 18.33px;
    height: 13.33px;
    object-fit: contain;
  }

  .meta-value {
    color: #3b4a47;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }
}

.action-row {
  .learn-btn {
    height: 40px;
    padding: 0 32px;
    border-radius: 8px;
    background: #00d8c3;
    border-color: #00d8c3;
    color: #ffffff;
    font-size: 14px;
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.25s ease;

    &:hover,
    &:focus {
      background: #00c4b0;
      border-color: #00c4b0;
      color: #ffffff;
    }
  }
}

/* Directory List layout (Bottom Section) */
.directory-section-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.directory-section-title-row {
  align-self: stretch;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  display: inline-flex;

  .title-left-bar {
    width: 6px;
    height: 24px;
    background: #00d8c3;
    border-radius: 9999px;
  }

  .title-text {
    color: #191c1e;
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
  }
}

.directory-list-container {
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
}

/* Chapter group card */
.chapter-card {
  align-self: stretch;
  background: white;

  overflow: hidden;
  border-radius: 16px;
  border: 1px solid rgba(186, 202, 198, 0.3);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.chapter-header-row {
  align-self: stretch;
  padding: 16px 32px;
  background: #f2f4f6;
  border-bottom: 1px solid rgba(186, 202, 198, 0.2);
  justify-content: flex-start;
  align-items: center;
  display: inline-flex;
  gap: 16px;
}

.chapter-step-badge-wrap {
  padding-right: 16px;
  display: inline-flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.chapter-step-badge {
  padding: 4px 16px;
  background: #00d8c3;
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
  color: white;
  font-size: 12px;

  font-weight: 700;
  line-height: 16px;
}

.chapter-header-title {
  color: #00d8c3;
  font-size: 18px;
  font-weight: 700;
  line-height: 28px;
}

.chapter-body-content {
  align-self: stretch;
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 32px;
}

/* Chapter focus and targets cards */
.chapter-goals-box {
  width: 100%;
  display: flex;
  gap: 24px;
  box-sizing: border-box;
}

.goal-card {
  flex: 1;
  padding: 16px;
  background: rgba(242, 244, 246, 0.3);
  border-radius: 12px;
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.goal-icon-wrap {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  flex-shrink: 0;
}

.goal-icon-block {
  width: 20px;
  height: 20px;

  border-radius: 4px;
}

.goal-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
}

.goal-title {
  color: #191c1e;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
}

.goal-text {
  color: rgba(59, 74, 71, 0.8);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

/* Chapter courses list */
.chapter-content-list-section {
  align-self: stretch;
  border-top: 1px solid rgba(186, 202, 198, 0.2);
  padding-top: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: flex-start;
  width: 100%;
}

.content-list-title-row {
  align-self: stretch;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  display: inline-flex;

  .content-list-icon {
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    color: #3b4a47;
    font-size: 16px;
  }

  .content-list-title-text {
    color: #191c1e;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
  }
}

.chapter-courses-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

/* Sub course card based on code.html markup specs */
.sub-course-card {
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid rgba(186, 202, 198, 0.3);
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  transition: all 0.25s ease;
  cursor: pointer;

  &:hover {
    border-color: #00d8c3;

    .sub-course-action {
      opacity: 1 !important;
    }
  }
}

.sub-course-left {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 16px;
}

.sub-course-number {
  width: 28px;
  height: 28px;
  background: #f2f4f6;
  border-radius: 9999px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  .num-text {
    color: #3b4a47;
    font-size: 12px;
    font-weight: 700;
  }
}
.sub-course-info {
  display: flex;
  align-items: center;
}

.sub-course-title-wrap {
  flex: 1;
  padding-right: 16px;
}

.sub-course-title {
  color: #191c1e;
  font-size: 15px;
  font-family: Inter, sans-serif;
  font-weight: 500;
}

.sub-course-badge {
  padding: 3px 10px;
  border-radius: 9999px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  &.completed {
    background: rgba(0, 216, 195, 0.1);
    .badge-text {
      color: #00d8c3;
    }
  }

  &.pending {
    background: #f2f4f6;
    .badge-text {
      color: #3b4a47;
    }
  }

  .badge-text {
    font-size: 11px;
    font-weight: 500;
    line-height: 1;
  }
}

.sub-course-action {
  opacity: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: opacity 0.25s ease;
  flex-shrink: 0;
  line-height: 1;

  .action-text {
    color: #00d8c3;
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
  }

  .action-arrow-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #00d8c3;
    font-size: 14px;
    font-weight: 700;
    line-height: 1;

    i {
      display: block;
    }
  }
}

/* Micro animations */
.btnTransform {
  transition: transform 0.2s ease;
}
.btnTransform:active {
  transform: scale(0.96);
}

.textOverflowOne {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.textOverflowTwo {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.textOverflowFour {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}

/* 查看更多课程按钮 */
.view-more-courses-btn {
  align-self: stretch;
  padding: 12px 0;
  border-radius: 12px;
  border: 1px solid rgba(186, 202, 198, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  background: #ffffff;
  transition: all 0.2s ease;
  user-select: none;
  width: 100%;
  margin-top: 12px;

  &:hover {
    background: #f8fafb;
    border-color: #00d8c3;
    .view-more-text {
      color: #00d8c3;
    }
    .view-more-arrow {
      color: #00d8c3;
    }
  }
}

.view-more-text {
  color: #3b4a47;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.view-more-arrow {
  display: flex;
  align-items: center;
  color: #3b4a47;
  font-size: 12px;
}
</style>
